import ApiService from '@/assets/js/api.service';

export const ACT_GET_EXCEL_DOWN_MNG_LIMIT = "getExcelDownMngLimit";
export const ACT_DOWNLOAD_EXCEL_DOWN_MNG_FILE = "getDownloadExcelDownMngFile";

const state = {
};

const mutations = {
};

const actions = {

    [ACT_GET_EXCEL_DOWN_MNG_LIMIT](context, params) {
        return new Promise(resolve => {
            ApiService.query('/v1/app/comexcel/down-mng/check/limit', params).then(response => resolve(response))
        });
    },
    [ACT_DOWNLOAD_EXCEL_DOWN_MNG_FILE](context, {excelDownMngSn, params, fileName}){
        ApiService.download(`/v1/app/download/excel/down-mng`, excelDownMngSn, params, fileName);
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};